<template>
  <CommonLoginV2 platform="cx" />
</template>

<script>
import CommonLoginV2 from '@/views/common/loginV2.optimized.vue';

export default {
  name: 'CxLoginV2',
  components: {
    CommonLoginV2
  }
};
</script>